import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import dept from './modules/dept'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules:{
    user,
    dept
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js